/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type RequestTicketMutationVariables = Types.Exact<{
  email: Types.Scalars["String"];
}>;

export type RequestTicketMutation = {
  requestTicket: Pick<Types.TicketRequestResponse, "status">;
};

export const RequestTicketDocument = gql`
  mutation RequestTicket($email: String!) {
    requestTicket(email: $email) {
      status
    }
  }
`;

/**
 * __useRequestTicketMutation__
 *
 * To run a mutation, you first call `useRequestTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTicketMutation, { data, loading, error }] = useRequestTicketMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestTicketMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RequestTicketMutation,
    RequestTicketMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RequestTicketMutation,
    RequestTicketMutationVariables
  >(RequestTicketDocument, baseOptions);
}
export type RequestTicketMutationHookResult = ReturnType<
  typeof useRequestTicketMutation
>;
export type RequestTicketMutationResult =
  ApolloReactCommon.MutationResult<RequestTicketMutation>;
export type RequestTicketMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RequestTicketMutation,
    RequestTicketMutationVariables
  >;
